import { RouteRecordRaw } from 'vue-router';

const dashboardRoutes: RouteRecordRaw[] = [
   {
      path: '/dashboard',
      name: 'dashboard-index',
      meta: { permission: 'dashboards' },
      component: () => import('@/modules/dashboard/pages/PowerBI.vue'),
   },
];

export default dashboardRoutes;
